import { Web3Address } from 'multirpc-sdk';

import { ANKR_PAYMENT_NETWORK } from 'modules/payments/const';
import { createQueryFnWithWeb3ServiceGuard } from 'store/utils/createQueryFnWithWeb3ServiceGuard';
import { createQuerySelectors } from 'store/utils/createQuerySelectors';
import { web3Api } from 'store/queries';

export interface IFetchIsOldAccountParams {
  account: Web3Address;
}

const fetchIsOldAccountFallback = false;

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchIsOldAccount },
  useFetchIsOldAccountQuery,
  useLazyFetchIsOldAccountQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchIsOldAccount: build.query<boolean, IFetchIsOldAccountParams>({
      queryFn: createQueryFnWithWeb3ServiceGuard({
        fallback: { data: fetchIsOldAccountFallback },
        queryFn: async ({ params: { account }, web3Service }) => {
          const hasOldPremium = await web3Service.isOldPremiumAndActiveToken(
            account,
            ANKR_PAYMENT_NETWORK,
          );

          return { data: hasOldPremium };
        },
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  selectDataWithFallbackCachedByParams: selectIsOldAccount,
  selectLoadingCachedByParams: selectIsOldAccountLoading,
  selectStateCachedByParams: selectIsOldAccountState,
} = createQuerySelectors({
  endpoint: fetchIsOldAccount,
  fallback: fetchIsOldAccountFallback,
});
